import { createSlice } from "@reduxjs/toolkit";

const headerSlice = createSlice({
  name: "header",
  initialState: {
    currentHeader: 0,
    subHeader: false,
  },
  reducers: {
    mobileHeader: (state) => {
      state.currentHeader = 1;
    },
  },
});

export const { mobileHeader } = headerSlice.actions;
export default headerSlice.reducer;
